import React, { useEffect, useState } from "react";
import { Table, Button, Pagination, message } from "antd";
import BannerDetail from "../pages/BannerDetail";
import CreateBannerModal from "../pages/CreateBannerModal";
import { subItemHooks } from "../hooks";
const BannerLayout = () => {
  const [banners, setBanners] = useState([]); // 배너 리스트
  const [loading, setLoading] = useState(false); // 로딩 상태
  const [page, setPage] = useState(1); // 현재 페이지
  const [total, setTotal] = useState(0); // 총 데이터 수
  const [selectedBanner, setSelectedBanner] = useState(null); // 선택한 배너 데이터
  const [isModalVisible, setIsModalVisible] = useState(false); // 모달 상태
  const [isCreateModalVisible, setIsCreateModalVisible] = useState(false);
  // API 호출 함수
  const fetchBanners = async (currentPage = 1) => {
    setLoading(true);
    try {
      const response = await subItemHooks.bannerList({ page: currentPage });
      console.log(response)
      const { data, cnt } = response.data;
      console.log(data);
      setBanners(data);
      setTotal(cnt);
    } catch (error) {
      console.error("배너 데이터를 가져오는 중 오류가 발생했습니다.", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      const res = await subItemHooks.bannerDelete({ id: id });
      if (res.IsError) {
        throw new Error("delete banner error");
      }
      message.success("배너가 삭제되었습니다.");
      fetchBanners(page);
      setIsModalVisible(false);
    } catch (error) {
      message.error("배너 삭제에 실패했습니다.");
    }
  };

  const handleUpdate = async (updateData) => {
    try {
      const res = await subItemHooks.bannerUpdate({
        banner: updateData.banner_url,
        bannerId: updateData.id,
        bannerLocation: updateData.banner_location,
        bannerUrl: updateData.banner_link,
        bannerPosition: updateData.banner_position,
      });
      if (res.IsError) {
        throw new Error("update banner error");
      }
      message.success("배너가 수정되었습니다.");
      fetchBanners(page);
      setIsModalVisible(false);
    } catch (error) {
      console.log(error, "catch");
      message.error("배너 수정에 실패했습니다.");
    }
  };

  const handleCreate = async (banner) => {
    try {
      const res = await subItemHooks.bannerCreate({
        bannerLink: banner.banner_link,
        bannerLocation: banner.banner_location,
        bannerUrl: banner.banner_url.split(",")[1],
        bannerPosition: banner.banner_position,
      });
      console.log(res);
      if (res.IsError) {
        throw new Error("create banner error");
      }
      message.success("새 배너가 생성되었습니다.");
      fetchBanners(page);
      setIsCreateModalVisible(false);
    } catch (error) {
      message.error("배너 생성에 실패했습니다.");
    }
  };

  useEffect(() => {
    fetchBanners(page);
  }, [page]);

  // 테이블 컬럼 정의
  const columns = [
    {
      title: "이미지",
      dataIndex: "banner_url",
      render: (url) => (
        <img
          src={url}
          alt="배너"
          style={{ width: 100, height: 50, objectFit: "cover" }}
        />
      ),
    },
    {
      title: "배너 위치",
      dataIndex: "banner_location",
      render: (location) =>
        (function () {
          if (location === "home") {
            return "홈";
          } else if (location === "group") {
            return "꼬꼬무리스트";
          } else if (location === "product") {
            return "제품리스트";
          } else {
            return "관심정보리스트";
          }
        })(),
    },
    {
      title: "배너 노출 순서",
      dataIndex: "banner_position",
    },
    {
      title: "배너 링크",
      dataIndex: "banner_link",
      render: (link) => (
        <a href={link} target="_blank" rel="noopener noreferrer">
          {link}
        </a>
      ),
    },
    {
      title: "생성일자",
      dataIndex: "created_at",
    },
    {
      title: "업데이트일자",
      dataIndex: "updated_at",
    },
    {
      title: "상세보기",
      render: (record) => (
        <Button
          type="link"
          onClick={() => {
            setSelectedBanner(record);
            setIsModalVisible(true);
          }}
        >
          상세 보기
        </Button>
      ),
    },
  ];

  return (
    <div>
      <div
        style={{
          marginBottom: "20px",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Button type="primary" onClick={() => setIsCreateModalVisible(true)}>
          배너 생성하기
        </Button>
      </div>
      <Table
        columns={columns}
        dataSource={banners}
        rowKey="id"
        pagination={false}
        loading={loading}
      />
      <Pagination
        current={page}
        total={total}
        pageSize={10}
        onChange={(page) => setPage(page)}
        style={{ marginTop: 20, textAlign: "center" }}
      />
      <BannerDetail
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        banner={selectedBanner}
        onUpdate={handleUpdate}
        onDelete={handleDelete}
      />
      <CreateBannerModal
        visible={isCreateModalVisible}
        onClose={() => setIsCreateModalVisible(false)}
        onCreate={handleCreate}
      />
    </div>
  );
};

export default BannerLayout;
